module.exports = __webpack_public_path__ + "assets/img/yp16.a77dbddd.jpg";